/**
 * @file 组件初始化入口
 */

import TTabs from './tabs.vue'
import TTabPanel from './tabs-panel.vue'

TTabs.install = Vue => {
  Vue.component(TTabs.name, TTabs)
}
TTabPanel.install = Vue => {
  Vue.component(TTabPanel.name, TTabPanel)
}

export {
  TTabs,
  TTabPanel
}



// WEBPACK FOOTER //
// ./src/module/tabs/index.js